<template>
  <div class="recent-keyword-wrapper">
    <template v-if="isVisibleEmptySearchKeyword">
      <div class="recent-keyword-header">최근 검색어</div>
      <div class="recent-keyword-body">
        <div class="recent-keyword-empty" v-if="prevSearchKeywordList.length === 0">
          <div class="attention-mark-area">
            <div class="icon">
              <EmptyIcon />
            </div>
          </div>
          <div class="info-text">
            최근 검색내역이 없네요.<br/>
            요즘 인기있는 검색어를 추천해드릴게요.
          </div>
          <div class="recommend-keyword-list">
          <span v-for="(keywordItem) in keywordList"
                :key="'empty-keyword' + keywordItem.text"
                @click.prevent="()=>moveToRecommendTag(keywordItem)"
                class="tag-item">
            {{keywordItem.text}}
          </span>
          </div>
        </div>
        <div class="recent-keyword-list" v-if="prevSearchKeywordList.length">
          <div class="recent-keyword-header">최근 검색어</div>
          <ul class="recent-keyword-list-body">
            <li v-for="(keyword, index) in prevSearchKeywordList" :key="keyword + index" @click.prevent="()=>searchByRecentKeyword(keyword)">
              <div class="prev-keyword">
                <span class="prev-keyword-txt">{{getClampText(keyword, 30)}}</span>
                <span class="prev-keyword-delete" @click.stop="()=>deleteRecentKeyword(keyword)"><DeleteIcon/></span>
              </div>
            </li>
          </ul>
          <a href="#" @click.stop="removeAllPrevSearchList" class="remove-all-prev-search-button">전체 내역 삭제</a>
        </div>
      </div>
    </template>
    <template v-if="isVisibleRecommendKeyword">
      <div class="keyword-list-wrapper">
        <div class="program-body" v-if="hasVodKeyword">
          <div :class="programHeaderFixClass" ref="programHeader">프로그램</div>
          <div class="keyword-list">
            <ul>
              <li v-for="(keyword, index) in vodKeywordListInfo.list" :key="keyword + index" @click.stop="()=>goProgram(keyword)">
                <div class="prev-keyword" v-html="setKeywordColor(keyword)"></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="movie-body" ref="movieBody" v-if="hasMovieKeyword">
          <div :class="movieHeaderFixClass" ref="movieHeader">영화</div>
          <div class="keyword-list">
            <ul>
              <li v-for="(keyword, index) in movieKeywordListInfo.list" :key="keyword + '_' + index" @click.stop="()=>goMovie(keyword)">
                <div class="prev-keyword" v-html="setKeywordColor(keyword)"></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { SearchService } from '@/common/api/api.service'
import { EventBus } from '@/components/eventbus/EventBus'
import { get, throttle } from 'lodash'
import { parse } from 'query-string'
import { LOCAL_STORAGE_PREV_SEARCH_KEY, MSG_ASK_DELETE_ALL_PREV_SEARCH_KEYWORD } from '@/common/constant'
import EmptyIcon from '@/assets/svg/common/img_empty.svg'
import DeleteIcon from '@/assets/svg/common/ic-delete.svg'
import { getStorage } from '@/common/util/storage.util'
import { mapGetters } from 'vuex'
import { getClampText } from '@/common/util/text.utils'
import utils from '@/common/util/utils'

export default {
  name: 'RecentSearchKeyword',
  components: {
    EmptyIcon,
    DeleteIcon
  },
  props: [ 'isVisibleEmptySearchKeyword', 'vodKeywordListInfo', 'movieKeywordListInfo', 'searchKeyword' ],
  data () {
    return {
      keywordList: [],
      prevSearchKeywordList: [],
      storage: {}
    }
  },
  methods: {
    getClampText: getClampText,
    setKeywordColor (keyword) {
      const str = keyword.displaykeywords
      return str.replace(this.searchKeyword, `<span class="dark-purple">${this.searchKeyword}</span>`)
    },
    whenEmptyRecentTagThenSetData () {
      SearchService.getRecommendSearchKeywordList().then(({ data }) => {
        this.keywordList = Object.assign([], data).splice(0, 5)
      })
    },
    moveToRecommendTag (keywordItem) {
      const uiCode = get(parse(keywordItem.link.split('?').pop()), 'uicode', '')
      if (uiCode !== '') {
        this.$router.push({ name: 'searchList', params: { uiCode: uiCode, section: uiCode } })
      } else {
        this.$router.push(keywordItem.link.replace('captvpooq://', '').replace('https://m.pooq.co.kr', '').replace('https://m.wavve.com', ''))
      }
    },
    async removeAllPrevSearchList () {
      if (await utils.asyncConfirm(MSG_ASK_DELETE_ALL_PREV_SEARCH_KEYWORD)) {
        this.prevSearchKeywordList = []
        this.storage.remove(LOCAL_STORAGE_PREV_SEARCH_KEY)
      }
    },
    deleteRecentKeyword (keyword) {
      this.prevSearchKeywordList = this.prevSearchKeywordList.filter((prevKeyword) => {
        return prevKeyword !== keyword
      })
      this.storage.set(LOCAL_STORAGE_PREV_SEARCH_KEY, this.prevSearchKeywordList.join(','))
    },
    searchByRecentKeyword (keyword) {
      EventBus.$emit('search-by-recent-keyword', { keyword })
    },
    goProgram (keyword) {
      this.$router.push(`/player/vod?programid=${keyword.programid}&search=y&referer=${this.$route.fullPath}`)
    },
    goMovie (keyword) {
      this.$router.push(`/player/movie?movieid=${keyword.movieid}&search=y&referer=${this.$route.fullPath}`)
    },
    fixHeaderControl: throttle(function (e) {
      if (!this.$refs.movieHeader || !this.$refs.movieBody) return
      const movieHeader = this.$refs.movieHeader
      const movieBodyY = this.$refs.movieBody.getBoundingClientRect().y
      // console.log(movieBodyY)
      // const scrollDirection = this.target.scrollTop <= 0 ? 'down' : 'up'
      if (movieBodyY <= 70) {
        movieHeader.classList.add('header-fix')
      }
      if (movieBodyY > 70) {
        movieHeader.classList.remove('header-fix')
      }
      // this.oldScrollTop = this.target.scrollTop
    }, 200)
  },
  computed: {
    ...mapGetters(['isVisibleSearchResult']),
    isVisibleRecommendKeyword () {
      return get(this.vodKeywordListInfo, 'count', 0) || get(this.movieKeywordListInfo, 'count', 0)
    },
    hasMovieKeyword () {
      let count = Number(get(this.movieKeywordListInfo, 'count', 0))
      return count > 0
    },
    hasVodKeyword () {
      let count = Number(get(this.vodKeywordListInfo, 'count', 0))
      return count > 0
    },
    programHeaderFixClass () {
      return this.hasVodKeyword ? 'program-header header-fix' : 'program-header'
    },
    movieHeaderFixClass () {
      return this.hasMovieKeyword ? 'movie-header' : 'program-header header-fix'
    }
  },
  created () { // 클릭할때로 변경해야
    this.storage = getStorage()
    // let prevKeywordList = this.storage.get(LOCAL_STORAGE_PREV_SEARCH_KEY) || ''
    // if (prevKeywordList !== '') {
    //   this.prevSearchKeywordList = prevKeywordList.split(',')
    //   this.prevSearchKeywordList = reverse(this.prevSearchKeywordList)
    // }
    this.whenEmptyRecentTagThenSetData()
  },
  mounted () {
    this.target = document
    this.target.addEventListener('scroll', this.fixHeaderControl)
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.fixHeaderControl)
  },
  watch: {
    isVisibleEmptySearchKeyword (newVal) {
      if (newVal) {
        let prevKeywordList = this.storage.get(LOCAL_STORAGE_PREV_SEARCH_KEY) || ''
        if (prevKeywordList !== '') {
          this.prevSearchKeywordList = prevKeywordList.split(',')
          let keywordList = this.prevSearchKeywordList.filter((data) => {
            if (data !== '') {
              return data
            }
          })
          this.prevSearchKeywordList = keywordList
        }
      }
    },
    isVisibleSearchResult () {
      if (this.isVisibleSearchResult) {

      }
    }
  }

}
</script>

<style scoped>
  .recent-keyword-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;

    /*left: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*background-color: #1b1b1b;*/
    /*z-index: 3000;*/
  }
  .recent-keyword-header {
    position: fixed;
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    background-color: #252525;
    line-height: 30px;
    padding-left: 10px;
    font-size: 11px;
    color: #a5a5a5;
    z-index: 50;
  }
  .recent-keyword-body {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #1b1b1b;
  }
  .recent-keyword-empty {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 72px;
  }
  .recent-keyword-body .recent-keyword-empty{
    padding-top: 142px;
  }
  .attention-mark-area .icon {
    position: relative;
    width: 50px;
    height: 50px;
    margin: 0 auto;
  }
  .info-text {
    margin-top: 16px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #a5a5a5;
  }
  .recommend-keyword-list {
    position: relative;
    top: 40px;
    width: 100%;
    padding: 0 5px 0 5px;
    height: 190px;
    text-align: center;
  }
  .tag-item {
    z-index: 100;
    display: inline-block;
    position: relative;
    top: 10px;
    min-width: 61px;
    margin: 10px 10px 0 0;
    padding: 6px 20px;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    color: #a5a5a5;
    border: 1px solid #a5a5a5;
    -moz-border-radius: 16px 16px 16px 16px;
    border-radius: 16px 16px 16px 16px;
  }
  .recent-keyword-list {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 70px;
  }
  .recent-keyword-list>ul li {
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #252525;
  }
  .prev-keyword {
    position: relative;
    padding: 20px 52px 20px 20px;
    overflow: hidden;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #a5a5a5;
  }
  .program-header,
  .movie-header {
    width: 100%;
    position:relative;
    height: 30px;
    box-sizing: border-box;
    background-color: #252525;
    line-height: 30px;
    padding-left: 10px;
    font-size: 11px;
    color: #a5a5a5;
    z-index: 50;
  }
  .movie-header {
    z-index: 400;
  }
  .program-body {
    position: relative;
    width: 100%;

    padding-top: 30px;
  }
  .header-fix{
    position: fixed;
    top: 70px;
    left: 0;
  }
  .keyword-list-wrapper{
    /*position: relative;*/
    /*left: 0;*/
    /*right: 0;*/
    /*top: 100px;*/
    /*bottom: 0;*/
    /*width: 100%;*/
    /*height: 100%;*/

    /*padding-top: 100px;*/

    padding-top: 70px;
  }
  .prev-keyword-txt{
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .prev-keyword-delete {
    position: absolute;
    top: 50%;
    margin-top: -6px;
    right: 20px;
    width: 12px;
    height: 12px;

  }
  .prev-keyword-delete svg{
    display: block;
  }
  .recent-keyword-list-body {
    padding-top: 30px;
  }
  .keyword-list{
    background-color: #1b1b1b;
  }
  .keyword-list li{
    border-bottom: 1px solid #252525;
  }

  /* 전체 내역 삭제 (검색) */
  .remove-all-prev-search-button{
    display: block;
    width: 120px;
    margin: 20px auto;
    padding: 10px 0;
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    text-align: center;
    border: 1px solid #fff;
    border-radius: 18px
  }
</style>
